import styled from "@emotion/styled";
import LogoPng from "../../assets/logo.png";
import EnviroLogoPng from "../../assets/enviro-logo.png";

const Image = styled("img")`
  max-width: 100%;
  height: auto;
`;

export default function Logo() {
  let app = process.env.REACT_APP_NAME;

  return (
    <>
      <Image src={app === "enviro"  ? EnviroLogoPng : LogoPng} alt="Logo" />

    </>
  );
}
